<template>
    <div class="load_bar_wrapper" v-show="load"><div class="load_bar"></div></div>
    <div class="header" v-show="!isLoading">
        <div class="logo_wrapper">
            <div :class="isAuth ? 'title_auth' : 'title_logo'">
                <div class="img_wrapper">
                    <img class="logo_img" src="/assets/img/logo.svg" />
                </div>

                <p class="header_title" v-if="!isAuth">{{$t('main.title')}}</p>
            </div>

            <div class="exit mb-0"  v-if="isAuth && !isLoading" @click="signOut">
                <img src="/assets/img/logout.svg"> {{$t('main.sign_out')}}
            </div>
        </div>
    </div>

    <div class="body flex mt-4" v-if="isAuth && !isLoading">

        <div class="body_content body_content_without_menu">
            <div v-show="!isShowInternalServerError" v-if="!isUpdating"><router-view /></div>
            <page500 v-show="isShowInternalServerError"></page500>
        </div>

    </div>

    <div class="body" v-if="!isAuth && !isLoading">
        <div class="auth_wrapper content_wrapper">
            <h1 class="m-0">{{$t('main.sign_in')}}</h1>
            <p class="auth_text">{{$t('main.sign_in_text')}}</p>
            <v-input class="mt-8" v-model="login" :label="$t('main.login')" :placeholder="$t('main.login_placeholder')" :inputType="'text'" :errorText="loginErrorText" height="28" @focus="loginErrorText = ''" @pressEnter="signIn" clearable></v-input>
            <v-input class="mt-7" v-model="password" :label="$t('main.password')" :placeholder="$t('main.password_placeholder')" :errorText="passwordErrorText" :inputType="passwordInputType" @changeType="changeType" height="28" @pressEnter="signIn" password @focus="passwordErrorText = ''"></v-input>
            <button :class="isLoginButtonDisable ? 'auth_button disable_button' : 'auth_button'" @click="signIn" :disable="isLoginButtonDisable">{{$t('main.sign_in_button')}}</button>
        </div>
    </div>

    <div class="even_messages_wrapper">
        <div class="error" v-for="error in errors" :key="error">
            <p class="my-0">{{$t(error)}}</p>
            <img class="error_close" src="/assets/img/close-red.svg" @click="closeError(error)" />
        </div>

        <div class="success" v-for="successMessage in successMessages" :key="successMessage">
            <p class="my-0">{{$t(successMessage)}}</p>
            <img class="success_close" src="/assets/img/close-green.svg" @click="closeSuccessMessages(successMessage)" />
        </div>
    </div>

</template>

<script lang="ts">
    import { defineComponent, nextTick } from 'vue';
    import { useCookies } from "vue3-cookies";
    import { axiosRequests } from './services/axiosinstance';
    import { switchLanguage, getCurrentLocal } from '@/i18n';
    import { Token } from './models/Token';
    import ViewPage500 from './components/ServicePages/Page500.vue';

    //interface MenuWrapper extends Menu  {
    //    hasSubItems: boolean,
    //    isOpen: boolean
    //}

    interface ComponentModel {
        isLoading: boolean,
        passwordInputType: string,
        login: string,
        password: string,
        loginErrorText: string,
        passwordErrorText: string,
        isLoginButtonDisable: boolean,
        errors: string[],
        successMessages: string[],
        //menu: MenuWrapper[],
        //isShowMenu: boolean,
        //unreadChatMessageCount: number,
        //isChatConnectionRetry: boolean,
        //hubConnection: any,
        //isChatStoppedBySystem: boolean,
        //isThrottled: boolean,
        //isNeedToUpdateUnreadChatMessages: boolean,
        isEnLanguageSelect: boolean,
        isUpdating: boolean,
    }

    export default defineComponent({
        name: 'App',
        data(): ComponentModel {
            return {
                isLoading: true,
                passwordInputType: "password",
                login: "",
                password: "",
                loginErrorText: "",
                passwordErrorText: "",
                isLoginButtonDisable: false,
                errors: [], 
                successMessages: [], 
                //menu: [],
                //isShowMenu: false,
                //unreadChatMessageCount: 0,
                //isChatConnectionRetry: false,
                //hubConnection: undefined,
                //isChatStoppedBySystem: false,
                //isThrottled: false,
                //isNeedToUpdateUnreadChatMessages: false,
                isEnLanguageSelect: false,
                isUpdating: false,
            }
        },
        methods: {
            switchLanguage: async function () {
                await switchLanguage(getCurrentLocal() === "ru" ? "en" : "ru");

                this.isUpdating = true;

                nextTick(() => { this.isUpdating = false; });
            },
            changeType: function () {
                if (this.passwordInputType == "password") this.passwordInputType = "text";
                else this.passwordInputType = "password"

            },
            signIn: async function () {
                if (!this.login) this.loginErrorText = 'main.login_placeholder';
                if (!this.password) this.passwordErrorText = 'main.password_placeholder';

                if (!this.login || !this.password) return;

                this.isLoginButtonDisable = true;
                this.isUpdating = true;
                await axiosRequests.post(process.env.VUE_APP_AUTH_URL, { login: this.login, password: this.password })
                    .then(
                        async (data: Token) => {
                            this.cookies.set("accessToken", data.accessToken, data.accessTokenLifetime + "s", "/", undefined, true);
                            this.cookies.set("refreshToken", data.refreshToken, data.refreshTokenLifetime + "s", "/", undefined, true);

                           // this.isShowMenu = window.innerWidth > 1565;

                            //await this.getMenu();


                            this.$store.commit('SET_ISAUTH', true);

                            //this.connectToChat();

                            this.password = "";
                            this.login = "";
                            this.passwordInputType = "password";
                            this.isLoginButtonDisable = false;
                            this.loginErrorText = "";
                            this.passwordErrorText = "";  
                            this.isUpdating = false;
                        }
                    )
                    .catch(
                        async (err: any) => {
                            this.isLoginButtonDisable = false;
                            this.isUpdating = false;

                            if (err.status == 401) {
                                 this.$store.commit('SET_ADD_ERROR', 'error.incorrect_login_or_password');
                            } else {
                                this.$store.commit('SET_ADD_ERROR', 'error.something_went_wrong');
                            }
                        }
                );
            },
            refreshJWTToken: async function (refreshToken: string) {
                this.isLoginButtonDisable = true;
                this.isUpdating = true;

                await axiosRequests.post(process.env.VUE_APP_REFRESH_URL, { refreshToken: refreshToken })
                    .then(
                        (data: Token) => {
                            this.cookies.set("accessToken", data.accessToken, data.accessTokenLifetime + "s", "/", undefined, true);
                            this.cookies.set("refreshToken", data.refreshToken, data.refreshTokenLifetime + "s", "/", undefined, true);

                            this.$store.commit('SET_ISAUTH', true);
                            this.isUpdating = false;
                        })
                         .catch(
                             async (err: any) => {
                                 this.isLoginButtonDisable = false;
                                 this.isUpdating = false;

                                 if (err.status == 401) {
                                      return;
                                 } else {
                                     this.$store.commit('SET_ADD_ERROR', 'error.something_went_wrong');
                                 }
                             }
                    );
            },
            //updateUnreadChatMessages: async function () {
            //    if (this.isThrottled) {
            //        this.isNeedToUpdateUnreadChatMessages = true;
            //        return;
            //    }

            //    this.isThrottled = true;

            //    await this.getUnreadChatMessagesCount();

            //    setTimeout(async () => {
            //        if (this.isNeedToUpdateUnreadChatMessages) {
            //            await this.getUnreadChatMessagesCount();
            //            this.isNeedToUpdateUnreadChatMessages = false;
            //        }

            //        this.isThrottled = false;
            //    }, 1000);
            //},
            checkCanIfAccessTokenValid: async function (): Promise<boolean> {
               // this.isChatConnectionRetry = true;
                const token = this.cookies.get("accessToken");

                if (token) return true;

                const refreshToken = this.cookies.get("refreshToken");

                if (!refreshToken) return false;

                try {
                    const result: Token = await axiosRequests.post(process.env.VUE_APP_REFRESH_URL, { refreshToken: refreshToken });

                    this.cookies.set("accessToken", result.accessToken, result.accessTokenLifetime + "s", "/", undefined, true);
                    this.cookies.set("refreshToken", result.refreshToken, result.refreshTokenLifetime + "s", "/", undefined, true);

                    return true;
                } catch {
                    return false;
                } 
            },
            //connectToChat: async function () {
            //    try {
            //        const token = this.cookies.get("accessToken");

            //        this.isChatStoppedBySystem = true;
            //        this.$store.commit('SET_HUBCONNECTION', undefined);
            //        this.hubConnection?.stop();

            //        this.hubConnection = new signalR.HubConnectionBuilder()
            //            .withUrl(`${process.env.VUE_APP_CHAT_URL}chathub`, { accessTokenFactory: () => token })
            //            .withAutomaticReconnect()
            //            .build();

            //        await this.hubConnection.start()

            //        this.hubConnection.invoke("EnterAdministrator")

            //        this.hubConnection.on("UpdateUnreadMessagesCount", () => this.updateUnreadChatMessages())

            //        nextTick(() => {
            //            this.$store.commit('SET_HUBCONNECTION', this.hubConnection);

            //            this.$store.commit('SET_IS_CHAT_RECONNECTING', false);
            //            this.$store.commit('SET_IS_CHAT_CONNECTED', true);
            //            this.isChatStoppedBySystem = false;
            //        });
                   
            //        this.isChatConnectionRetry = false;

            //        this.getUnreadChatMessagesCount();

            //        this.hubConnection.onreconnecting(async () => {
            //            this.$store.commit('SET_IS_CHAT_RECONNECTING', true);
            //        })

            //        this.hubConnection.onreconnected(async () => {
            //            await this.connectToChat();
            //        })

            //        this.hubConnection.onclose(async () => {
            //            if (this.isChatStoppedBySystem) return;

            //            if (this.isChatConnectionRetry) {
            //                this.$store.commit('SET_ADD_ERROR', 'error.chat_connection_lost');
            //                this.$store.commit('SET_IS_CHAT_RECONNECTING', false);
            //                this.$store.commit('SET_IS_CHAT_CONNECTED', false);
            //                return;
            //            }

            //            if (!await this.checkCanIfAccessTokenValid()) {
            //                this.$store.commit('SET_ADD_ERROR', 'error.chat_connection_lost');
            //                this.$store.commit('SET_IS_CHAT_RECONNECTING', false);
            //                this.$store.commit('SET_IS_CHAT_CONNECTED', false);
            //                return;
            //            }

            //            await this.connectToChat();
            //        })

            //    }
            //    catch (e: any) {
            //        if (this.isChatStoppedBySystem) return;

            //        if (this.isChatConnectionRetry) {
            //            this.$store.commit('SET_ADD_ERROR', 'error.chat_connection_lost');
            //            this.$store.commit('SET_IS_CHAT_RECONNECTING', false);
            //            this.$store.commit('SET_IS_CHAT_CONNECTED', false);
            //            return;
            //        }

            //        if (!await this.checkCanIfAccessTokenValid()) {
            //            this.$store.commit('SET_ADD_ERROR', 'error.chat_connection_lost');
            //            this.$store.commit('SET_IS_CHAT_RECONNECTING', false);
            //            this.$store.commit('SET_IS_CHAT_CONNECTED', false);
            //            return;
            //        }

            //        await this.connectToChat();
            //    }
            //},
            //getMenu: async function () {
            //    await axiosRequests.get(editUrl(Routes.getMenu))
            //        .then(
            //            (data: Menu[]) => {
            //                this.menu = [];
            //                for (let i = 0; i < data.length; i++) {
            //                    this.menu.push({
            //                        icon: data[i].icon,
            //                        text: data[i].text,
            //                        url: data[i].url,
            //                        subItems: data[i].subItems,
            //                        hasSubItems: data[i].subItems?.length > 0,
            //                        isOpen: this.activeMenuItem == data[i].url
            //                    })
            //                }
            //            }
            //        )
            //        .catch(
            //            async (err: any) => {
            //                if (err.status == 401) {
            //                    return;
            //                } else if (err.status == 400 && err.data) {
            //                    this.$store.commit('SET_ADD_ERROR', err.data);
            //                } else {
            //                    this.$store.commit('SET_ADD_ERROR', 'error.something_went_wrong');
            //                }
            //            }
            //        );
            //},
            //getUnreadChatMessagesCount: async function () {
            //    let clubs = this.$store.getters.getSelectedClubId;
            //    if (!clubs || clubs == "0") clubs = this.availableClubs.map(x => x.id).toString();

            //    await axiosRequests.get(`${process.env.VUE_APP_CHAT_URL}Chat/GetUnreadMessagesCount?clubs=${clubs}`)
            //        .then(
            //            (data: number) => {
            //                this.unreadChatMessageCount = data;
            //            }
            //        )
            //        .catch(
            //            async (err: any) => {
            //                if (err.status == 401) {
            //                    return;
            //                } else if (err.status == 400 && err.data) {
            //                    this.$store.commit('SET_ADD_ERROR', err.data);
            //                } else {
            //                    this.$store.commit('SET_ADD_ERROR', 'error.something_went_wrong');
            //                }
            //            }
            //        );
            //},
            closeError: function (error) {
                let index = this.errors.findIndex(x => x == error);
                if (index != -1) this.errors.splice(index, 1);
                this.$store.commit('SET_REMOVE_ERROR', error);
            },
            closeSuccessMessages: function (successMessages) {
                let index = this.successMessages.findIndex(x => x == successMessages);
                if (index != -1) this.successMessages.splice(index, 1);
                this.$store.commit('SET_REMOVE_SUCCESS_MESSAGES', successMessages);
            },
            //clickOnMenuItem(item: MenuWrapper) {
            //    if (!item || !item.url) {
            //        console.log("Ошибка с переходом на страницу");
            //        console.log(`${item.text.toString()} | ${item.url.toString()}`);
            //        for (let i = 0; i < this.menu.length; i++)  console.log(`${this.menu[i].text.toString()} | ${this.menu[i].url.toString()}`);
            //        return;
            //    }

            //    if (item.hasSubItems) {
            //        item.isOpen = !item.isOpen;
            //    } else {
            //        if(window.innerWidth <= 1565) this.isShowMenu = false;
            //        this.$router.push(item.url);
            //    }
            //},
            //clickOutsideMenu: function (e: any) {
            //    if (!e.target.classList || e.target.classList?.contains('hamburger_button')) return;
            //    if (window.innerWidth <= 1565) this.isShowMenu = false;
            //},
            signOut: function () {
                //this.isShowMenu = false;
                this.$store.commit('SET_ISAUTH', false);

                this.cookies.remove("accessToken");
                this.cookies.remove("refreshToken");              

                //this.isChatStoppedBySystem = true;
                //this.hubConnection.stop();
            },
        },
        async created() {
            const local = localStorage.getItem("user-locale");

            if (local !== getCurrentLocal() && local != 'null') await switchLanguage(local);

            this.isEnLanguageSelect = getCurrentLocal() !== "ru";
        },
        setup() {
            const { cookies } = useCookies();
            return { cookies };
        },
        watch: {
            'errorsCount': function () {
                let errors = this.$store.getters.getErrors;
                for (let i = 0; i < errors.length; i++) {
                    if (!this.errors.includes(errors[i])) {
                        this.errors.push(errors[i]);
                        setTimeout(this.closeError, 5000, errors[i]);
                    }
                }
            },
            'successMessagesCount': function () {
                let successMessages = this.$store.getters.getSuccessMessages;
                for (let i = 0; i < successMessages.length; i++) {
                    if (!this.successMessages.includes(successMessages[i])) {
                        this.successMessages.push(successMessages[i]);
                        setTimeout(this.closeSuccessMessages, 5000, successMessages[i]);
                    }
                }
            },
            'isAuth': function () {
               // if (!this.isAuth) this.hubConnection?.stop();
            }
        },
        computed: {
            //activeMenuItem: function () {
            //    return getUrlPlural(this.$store.getters.getActiveMenu);
            //},
            //activeSubmenuItem: function () {
            //    return getUrlPlural(this.$store.getters.getActiveSubmenu);
            //},
            errorsCount: function () {
                return this.$store.getters.getErrors.length;
            },
            successMessagesCount: function () {
                return this.$store.getters.getSuccessMessages.length;
            },
            load: function () {
                return this.$store.getters.getLoad;
            },
            isAuth: function () {
                return this.$store.getters.getIsAuth;
            },
            isShowInternalServerError: function () {
               return this.$store.getters.getIsShowInternalServerError;
            }
        },
        components: { page500: ViewPage500 },
        async beforeMount() {

            let token = this.cookies.get("accessToken");
            let refreshToken = this.cookies.get("refreshToken");

            if (token) {
                this.$store.commit('SET_ISAUTH', true);
            } else if (refreshToken) {
                this.refreshJWTToken(refreshToken);
            }

            //if (this.isAuth) {
            //  //  this.isShowMenu = window.innerWidth > 1565;

            //    //await this.getMenu();
            //    //this.connectToChat();
            //}
            
            this.isLoading = false;
        }
    });
</script>

<style scoped>
    .header {
        background-color: white;
        padding: 12px 24px 12px 24px;
        display: flex;
        justify-content: space-between;
    }

    .user_wrapper{
        display: flex;
    }

    .user_name {
        margin: 0px;
        display: flex;
        flex-flow: row-reverse;
    }

    .user_photo {
        background-size: cover;
        width: 31px;
        height: 31px;
        margin: auto;
        border: 1px solid white;
        border-radius: 50%;
        background-position: center center;
    }

  
    .hamburger_button {
        cursor: pointer;
        height: 32px;
        margin-right: 25px;
    }

    .header_title {
        margin: 3px 0px 3px 17px;
        font-size: 20px;
        font-weight: bold;
    }

    .logo_wrapper{
        display: flex;
        width: 100%;
        justify-content: space-between;
    }

    .auth_wrapper {
        width: 375px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
        left: 50%;
    }

    .auth_button {
        width: 100%;
        background-color: #21A7D1;
        border-radius: 15px;
        border: none;
        margin-top: 24px;
        color: white;
        height: 44px;
        font-size: 18px;
        cursor: pointer;
    }

    .auth_text {
        line-height: 24px;
    }

    .body {
        height: 100vh;
    }

    .even_messages_wrapper {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 9999999999
    }

    .error {
        position: relative;
        background-color: #FBE0E0;
        color: #E22E2E;
        border-left: 4px solid #E22E2E;
        border-radius: 4px;
        display: flex;
        width: 360px;
        padding: 16px 16px 16px 20px;
        gap: 4px;
        margin: 0px 0px 10px 0px;
        animation: showEventMessage 6s linear;
        z-index: 9999999999
    }

    .error_close {
        position: absolute;
        top: 10px;
        right: 10px;
        height: 10px;
        cursor: pointer;
    }

    .success {
        position: relative;
        background-color: #b8ffb8;
        color: #008000;
        border-left: 4px solid #008000;
        border-radius: 4px;
        display: flex;
        width: 360px;
        padding: 16px 16px 16px 20px;
        gap: 4px;
        margin: 0px 0px 10px 0px;
        animation: showEventMessage 6s linear;
        z-index: 9999999999
    }

    .success_close {
        position: absolute;
        top: 10px;
        right: 10px;
        height: 10px;
        cursor: pointer;
    }

    .menu_wrapper {
        display: flex;
        flex-flow: column;
        border-radius: 0px 24px 24px 0px;
        background-color: white;
        padding: 24px;
        width: 230px;
        height: max-content;
        min-width: 230px;
        position: fixed;
        z-index: 3;
    }

    .menu_item_wrapper{
        text-decoration: none
    }

    .menu_item {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #101111;
        margin-bottom: 24px;
        cursor: pointer;
        position: relative;
    }

    .exit {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #101111;
        margin-bottom: 24px;
        cursor: pointer;
        position: relative;
    }

    .menu_active {
        filter: invert(60%) sepia(85%) saturate(1444%) hue-rotate(157deg) brightness(87%) contrast(86%);
    }

    .menu_item_arrow {
        position: absolute;
        right: 0px;
        height: 20px;
    }

    .hr {
        margin: 0px;
        background-color: #D5D5D5;
        height: 1px;
    }

    .menu_mobile_search{
        display: none;
    }

    .close_button {
        height: 24px;
        display: none;
    }

    .body_content {
        padding-inline: 16px;
        width: calc(100% - 32px);
        max-width: calc(100vw - 310px)
    }

    .unread_messages_count {
        background-color: #F7C9E4;
        border-radius: 12px;
        padding: 3px 10px 4px 10px;
        margin-left: 12px;
        font-size: 13px;
        color: #AB0064;
        height: 14px;
        display: flex;
        margin-top: 0px;
        position: absolute;
        right: 0px;
    }

    .unread_messages_count p {
        width: 17px;
        text-align: center;
    }

    .options_wrapper {
        position: absolute;
        right: 0;
        display: flex;
        flex-flow: column;
        background-color: white;
        width: -moz-max-content;
        width: max-content;
        border: 1px solid #D5D5D5;
        border-radius: 12px;
        top: 37px;
        overflow: hidden;
        min-width: 270px;
        z-index: 4;
        padding: 18px;
        box-shadow: 1px 3px 10px #d5d5d5;
    }

    .switcher {
        display: inline-block;
        height: 20px;
        line-height: 20px;
        position: relative;
        vertical-align: middle;
        font-size: 14px;
        user-select: none;
        cursor: pointer;
    }

    .switcher_switch {
        position: relative;
        display: inline-block;
        box-sizing: border-box;
        width: 40px;
        height: 20px;
        border: 1px solid #21A7D1;
        vertical-align: top;
        background: #C7E9F3;
        transition: .2s;
        border-radius: 18px;
    }

    .switcher_switch:before {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: #21A7D1;
        transition: .15s;
    }

    .switcher input[type=checkbox]:checked + .switcher_switch:before {
        transform: translateX(19px);
    }

    .calling_wrapper {
        background: rgb(160, 42, 123);
        display: flex;
        position: fixed;
        width: 90px;
        height: 90px;
        z-index: 10;
        top: 65px;
        right: 55px;
        border-radius: 50%;
        transform: scale(1);
        cursor: pointer;
        animation: pulse 2s infinite;
    }

    .current_club_wrapper {
        min-width: 350px;
        margin-left: 15px;
        height: 35px;
    }

    .menu_wrapper_hide {
        display: none;
        animation: hideMenu 0.2s linear;
    }

    .menu_wrapper_show {
        display: flex;
        box-shadow: 0px 0px 10px #d5d5d5;
        animation: showMenu 0.2s linear;
    }

    .body_content_with_menu {
        margin-left: 280px;
        animation: moveLeftBoby 0.2s linear;
    }

    .body_content_without_menu {
        max-width: calc(100vw - 32px);
        animation: moveRightBoby 0.2s linear;
    }

    .network_logo {
        height: 36px;
        width: auto;
    }

    .title_auth{
        display: flex;
    }

    .title_logo {
        display: flex;
    }

    @media(max-width: 1565px) {
        .body_content {
            max-width: calc(100vw - 32px)
        }

        .body_content_with_menu {
            margin-left: 0px;
            animation: unset;
        }

        .body_content_without_menu {
            max-width: calc(100vw - 32px);
            animation: unset;
        }
    }


    @media(max-width: 1200px) {
        .user_wrapper {
            display: none;
        }

        .search_wrapper {
            max-width: 80%;
            margin-inline: 0px;
            margin-left: 20px;
        }
    }
    
    @media(max-width: 960px) {
        .current_club_wrapper {
            min-width: 250px;
        }
    }

    @media(max-width: 768px) {
        .logo_wrapper {
            display: flex;
            width: 100%;
            justify-content: space-between;
        }

        .hamburger_button {
            height: 24px;
            margin: 0px;
        }


        .logo_img {
            height: 24px;
        }

        .network_logo {
            height: 25px;
        }

        .logo_buttons_wrapper {
            order: 1;
        }

        .header_title {
            margin: 0px 0px 0px 17px;
        }

        .menu_wrapper {
            border-radius: 0px 0px 24px 24px;
            position: absolute;
            left: 0;
            right: 0;
            top: 48px;
            width: auto;
            padding-top: 0px;
            max-height: calc(100vh - 67px);
            overflow: auto;
        }

        .menu_mobile_search {
            display: block;
        }

        .menu_mobile_wrapper_hide {
            display: none;
            animation: hideMenuFromTop 0.2s normal;
        }

        .menu_mobile_wrapper_show {
            display: flex;
            box-shadow: 0px 7px 5px #d5d5d5;
            animation: showMenuFromTop 1s normal;
        }

        .mobile_hide{
            display: none;
        }

        .mobile_show {
            display: block;
        }
    }

    @media(max-width: 500px) {
        .auth_wrapper {
            width: auto;
            position: static;
            transform: unset;
            margin-top: 8px;
        }

        .error {
            width: calc(100vw - 40px);
        }

        .options_wrapper {
            border-radius: 0px 0px 24px 24px;
            position: absolute;
            left: -1px !important;
            right: -1px;
            top: 48px !important;
            width: auto;
            padding-top: 18px;
            max-height: calc(100vh - 67px);
            overflow: auto;
        }

        .options_mobile_wrapper_show {
            display: flex;
            box-shadow: 0px 7px 5px #d5d5d5;
            animation: showMenuFromTop 1s normal;
        }

        .options_mobile_wrapper_hide {
            display: none;
            animation: hideMenuFromTop 1s normal;
        }

        .exit {
            font-size:12px;
        }

        .exit img {
            height: 14px;
        }

        .title_logo {
            display: flex;
            justify-content: space-between;
            width: 100%
        }

    }

    @media screen and (orientation:landscape) {
        .header{
            display: none;
        }
    }

    .load_bar_wrapper {
        position: absolute;
        height: 3px;
        display: block;
        width: 100%;
        background-color: white;
        overflow: hidden;
        top: 0;
    }

    .load_bar {
        background-color: #21A7D1;
    }

    .load_bar::before {
        content: '';
        position: absolute;
        background-color: inherit;
        top: 0;
        left: 0;
        bottom: 0;
        will-change: left, right;
        animation: indeterminate 3.5s infinite;
    }

    @keyframes pulse {

        0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(160, 42, 123, 0.7);
        }

        70% {
            transform: scale(1);
            box-shadow: 0 0 0 30px rgba(160, 42, 123, 0);
        }

        100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(160, 42, 123, 0);
        }
    }


    @keyframes indeterminate {
        0% {
            left: -35%;
            right: 100%;
        }

        100% {
            left: 100%;
            right: -200%;
        }
    }

    @keyframes showEventMessage {
        0% {
            left: 405px;
        }

        5% {
            left: 0px;
        }

        79% {
            left: 0px;
        }

        84% {
            left: 405px;
        }
        100% {
            display: none;
        }
    }

    @keyframes showMenu {
        0% {
            left: -250px;
        }

        100% {
            left: 0;
        }
    }

    @keyframes hideMenu {
        0% {
            display: flex;
            left: 0px;
        }

        100% {
            display: flex;
            left: -350px;
        }
    }

    @keyframes moveLeftBoby{
        0% {
            margin-left: 0px;
            max-width: calc(100vw - 32px);
        }

        100% {
            margin-left: 280px;
            max-width: calc(100vw - 310px);
        }
    }

    @keyframes moveRightBoby {
        0% {
            margin-left: 280px;
        }

        99% {
            margin-left: 0px;
        }

        100% {
            max-width: calc(100vw - 32px);
        }
    }

    @keyframes showMenuFromTop {
        0% {
           max-height: 0;
           overflow: hidden;
        }

        100% {
            overflow: hidden;
            max-height: 5000px;
        }
    }

    @keyframes hideMenuFromTop {
        0% {
            display: flex;
            max-height: 100vh;
            overflow: hidden;
        }

        100% {
            display: flex;
            overflow: hidden;
            max-height: 0;
        }
    }
    
    
</style>
